import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Lisa_Pet/subs.vtt';
import poster from '@/static/assets/reviews/Lisa_Pet/video.jpg';

export const Lisa: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Lisa',
  videoUrl: `${ASSETS_URL}/pet/Lisa_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
